"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RecurrenceType = exports.PlannedDeliveryWindowsFilterGroups = void 0;
var PlannedDeliveryWindowsFilterGroups;
(function (PlannedDeliveryWindowsFilterGroups) {
    PlannedDeliveryWindowsFilterGroups["Team"] = "team_id";
})(PlannedDeliveryWindowsFilterGroups = exports.PlannedDeliveryWindowsFilterGroups || (exports.PlannedDeliveryWindowsFilterGroups = {}));
var RecurrenceType;
(function (RecurrenceType) {
    RecurrenceType["current"] = "current";
    RecurrenceType["current_and_following"] = "current_and_following";
    RecurrenceType["all"] = "all";
})(RecurrenceType = exports.RecurrenceType || (exports.RecurrenceType = {}));
//# sourceMappingURL=planned-delivery-windows.consts.js.map